<script setup lang="ts">
import LoginDialog from "@/components/LoginDialog.vue";
import LogoutDialog from "@/components/LogoutDialog.vue";
import EditionDialog from "@/components/EditionDialog.vue";
import EditionDownloadDialog from "@/components/EditionDownloadDialog.vue";
import DeviceLimitDialog from "@/components/DeviceLimitDialog.vue";
import { config } from "@/lib/variantConfig";
import { useHead } from "@unhead/vue";
import { useAuthStore } from "@/stores/authStore";
import { useContentStore } from "@/stores/contentStore";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import { onMounted } from "vue";
import { DialogRoot } from "reka-ui";
import DialogContent from "@/components/DialogContent.vue";

const authStore = useAuthStore();
const contentStore = useContentStore();
const route = useRoute();

onMounted(() => {
  if (route.path.startsWith("/edition/")) {
    authStore.showLoginModal = false;
  }
});

useHead({
  titleTemplate: `%s - ${config.strings.app_name}`,
});

onBeforeRouteLeave(() => {
  contentStore.closeModals();
});
</script>

<template>
  <div>
    <slot />
    <DialogRoot v-if="authStore.user" v-model:open="authStore.showLogoutModal">
      <DialogContent>
        <LogoutDialog />
      </DialogContent>
    </DialogRoot>
    <DialogRoot v-else v-model:open="authStore.showLoginModal">
      <DialogContent size="lg">
        <LoginDialog />
      </DialogContent>
    </DialogRoot>
    <DialogRoot v-model:open="contentStore.showEditionModal">
      <DialogContent size="lg">
        <EditionDialog />
      </DialogContent>
    </DialogRoot>
    <DialogRoot
      v-model:open="contentStore.showDownloadModal"
      v-slot="{ close }"
    >
      <DialogContent>
        <EditionDownloadDialog @close="close" />
      </DialogContent>
    </DialogRoot>
    <DeviceLimitDialog />
  </div>
</template>
